import { CircularProgress, Progress } from '@/components/ui';

export function LoadingBar({ loading }: { loading: boolean }) {
  return (
    <div className='flex h-4 flex-row items-center'>
      {loading ? (
        <Progress isIndeterminate aria-label='Loading...' size='sm' />
      ) : (
        <div className='min-h-1' />
      )}
    </div>
  );
}

export function LoadingCircle({ loading = true }: { loading?: boolean }) {
  return (
    loading && (
      <div className='flex flex-row items-center'>
        <CircularProgress isIndeterminate aria-label='Loading...' size='lg' />
      </div>
    )
  );
}
